import { useCallback } from "react";

import { styled } from "@linaria/react";
import { match } from "ts-pattern";

import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

import ProjectConfigureStep from "@/pages/projects/forms/create/components/steps/ProjectConfigureStep";
import ProjectSelectMappingMethodStep from "@/pages/projects/forms/create/components/steps/ProjectSelectMappingMethodStep";
import ProjectSelectProjectSourcesStep from "@/pages/projects/forms/create/components/steps/ProjectSelectProjectSourcesStep";
import { useCreateProjectFormContext } from "@/pages/projects/forms/create/hooks";
import { CreateProjectFormStep } from "@/pages/projects/forms/create/types";

const CreateProjectModalBodyWrapper = withTheme(styled.div<PropsWithTheme>`
  width: 100%;
  height: 100%;
`);

const CreateProjectModalBody = () => {
  const { state } = useCreateProjectFormContext();

  const render = useCallback(
    () =>
      match(state.step)
        .returnType<React.ReactNode | null>()
        .with(CreateProjectFormStep.SELECT_PROJECT_SOURCES, () => (
          <ProjectSelectProjectSourcesStep />
        ))
        .with(CreateProjectFormStep.SELECT_MAPPING_METHOD, () => <ProjectSelectMappingMethodStep />)
        .with(CreateProjectFormStep.CONFIGURE_PROJECT, () => <ProjectConfigureStep />)
        .exhaustive(),
    [state.step],
  );

  return <CreateProjectModalBodyWrapper>{render()}</CreateProjectModalBodyWrapper>;
};

export default CreateProjectModalBody;
